/**
 * 사용할 때
 * state: state.moduleName.stateName
 * getters: computed(() => store.getters["moduleName/getterName"])
 * mutation: store.commit("moduleName/mutationName", params)
 * action은 store.dispatch("moduleName/actionName", params)
 */


const initLocale = () =>{
//  const windowLang = window.navigator.language.split('-')[0]
//  if(windowLang != "en" && windowLang != "mn" && windowLang != "ko") {
//     return "en"
//  }
  const windowLang = "en";

 return windowLang
}

export default {
  namespaced: true,
  state: {
    locale: initLocale()
  },
  getters: {
    getLocale: function(state) {
      return state.locale;
    }
  },
  mutations: {
    SAVE(state, { locale}) {
      state.locale = locale;
    },
    FLUSH(state){
      state.locale = "";
    }
  },
  actions: {
    flush(context){
      context.commit('FLUSH')
    },
    saveLocale(context, {locale}) {
      context.commit('SAVE', {locale})
    },
  },
}